import React, { useEffect, useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  IconButton,
  Tooltip,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import CustomPagination from "./CustomPagination";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import axios from "axios";
import UserHieTable from "./UserHieTable";
import { useNavigate } from "react-router-dom";
const MaterialUISwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 38,
  height: 22,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 18,
    height: 18,
  },
  "& .MuiSwitch-track": {
    borderRadius: 13,
    backgroundColor: "#FF4D4D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const UserTable = ({
  roleId,
  partnerName,
  partners,
  tablemsg,
  handleViewOpen,
  handleEditOpen,
  handleOpenModal,
  handleStatusToggle,
  pageSize,
  currentPage,
  totalRecords,
  handlePageChange,
  handlePageSizeChange,
  totalPages,
}) => {
  const [userType, setUserType] = useState("");
  const navigate = useNavigate();  // Step 2: Initialize navigate function

  useEffect(() => {
    const storedUserType = sessionStorage.getItem("uType");
    setUserType(storedUserType);
  }, []);

  const handleSeeHierarchy = async (row, breadcrumb = []) => {
    console.log("See Hierarchy clicked for user:", row.userid);
  
    try {
      const response = await axios.get(
        `https://api.ipaisa.co.in/myapp/auth/hierarchyFlowChart`, 
        { params: { userId: row.userid } }
      );
  
      console.log("Children Data:", response.data);
  
      // **New Breadcrumb Update**
      const newBreadcrumb = [...breadcrumb, row.userid];
  
      navigate("/UserHieTable", { 
        state: { 
          userId: row.userid, 
          hierarchyData: response.data.body, 
          partnerName: partnerName,
          breadcrumb: newBreadcrumb // Send updated breadcrumb
        } 
      });
    } catch (error) {
      console.error("Error fetching hierarchy data:", error);
    }
  };
  

  const isAdmin = userType === "ADMIN"; // Adjust based on your roles
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ marginTop: 2, borderRadius: 2, boxShadow: 3, overflowX: "auto" }}
      >
        <Table>
          <TableHead sx={{ backgroundColor: "#027BFE" }}>
            <TableRow>
              {[
                "Sr. No.",
                "User ID",
                "Parent ID",
                "Name",
                "Business Name",
                "Mobile Number",
                "Wallet Balance",
                "Status",
              ]
                .concat(isAdmin ? ["Actions"] : [])
                .map((header) => (
                  <TableCell
                    key={header}
                    sx={{
                      color: "#FFFFFF",
                      fontWeight: "bold",
                      fontSize: "1rem",
                      padding: "10px",
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {partners.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  {tablemsg || "No records found."}
                </TableCell>
              </TableRow>
            ) : (
              partners.map((row, index) => (
                <TableRow
                  key={row.userid}
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#C1E0FB",
                  }}
                >
                  <TableCell>{currentPage * pageSize + index + 1}</TableCell>
                  <TableCell>
                    <Tooltip
                      title={
                        <div>
                          <strong>Name:</strong>{" "}
                          {`${row.firstName || ""} ${row.middleName || ""} ${row.lastName || ""}`.trim()}{" "}
                          <br />
                          <strong>Parent ID:</strong> {row.parentId} <br />
                          <strong>Business Name:</strong> {row.bussinessName}{" "}
                          <br />
                          <strong>Mobile Number:</strong> {row.mobileNumber}{" "}
                          <br />
                          <strong>Wallet Balance:</strong> ₹
                          {Number(row.walletBalance).toFixed(2)} <br />
                          <strong>Status:</strong> {row.status} <br />
                          <strong>Percentage:</strong> {row.percentage} <br />
                        </div>
                      }
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", color: "#027BFE" }}>
                        {row.userid}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell>{row.parentId}</TableCell>
                  <TableCell>
                    {`${row.firstName || ""} ${row.middleName || ""} ${row.lastName || ""}`.trim()}
                  </TableCell>
                  <TableCell>{row.bussinessName}</TableCell>
                  <TableCell>{row.mobileNumber}</TableCell>
                  <TableCell>₹{Number(row.walletBalance).toFixed(2)}</TableCell>
                  <TableCell> 
                      <MaterialUISwitch
                          checked={row.status === "ACTIVE"}
                          onChange={isAdmin ? () => handleStatusToggle(row.userid, row.status, roleId) : undefined}
                          disabled={!isAdmin} // Prevent interaction for non-admin users
                      />
                  </TableCell>


                  {isAdmin && (
                    <TableCell>
                      <Tooltip title="View Details">
                        <IconButton
                          onClick={() => handleViewOpen(row)}
                          sx={{ color: "#027BFE" }}
                        >
                          <Visibility fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Edit User">
                        <IconButton
                          onClick={() => handleEditOpen(row)}
                          sx={{ color: "#FFA500" }}
                          disabled={!isAdmin}
                        >
                          <Edit fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete User">
                        <IconButton
                          onClick={() => handleOpenModal(row)}
                          sx={{ color: "#FF0000" }}
                          disabled={!isAdmin}
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="See Hierarchy">
                        <IconButton
                          onClick={() => handleSeeHierarchy(row)}
                          sx={{ color: "#4CAF50", "&:hover": { color: "green" } }}
                        >
                          <AccountTreeIcon fontSize="small" /> {/* Icon representing hierarchy */}
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  )}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPagination
        currentPage={currentPage}
        pageSize={pageSize}
        totalRecords={totalRecords}
        handlePageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
        totalPages={totalPages}
        sx={{ marginBottom: 2 }}
      />
    </>
  );
};

export default UserTable;
